import * as PS from './../models/page-state';

import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class PageStateService {
  private pageList = {
    [PS.HOME_PAGE]: 0,
    [PS.MEMBERSHIP_PAGE] : 0,
    [PS.MEMBERSHIP_DETAIL_PAGE] : 0,
    [PS.MY_MEMBERSHIP_PAGE] : 0,
    [PS.DUTYFREE_LISTING_PAGE] : 0,
    [PS.DUTYFREE_DETAIL_PAGE] : 0,
    [PS.PRODUCT_DETAIL_PAGE] : 0,
    [PS.RETAIL_CART_PAGE] : 0,
    [PS.AUTOCHECKOUT_FORM] : 0,
    [PS.SEARCH_FLIGHT_PAGE] : 0,
    [PS.FLIGHT_ARRIVAL_PAGE] : 0,
    [PS.FLIGHT_DEPARTURE_PAGE] : 0,
    [PS.FLIGHT_DETAIL_PAGE] : 0,
    [PS.MY_FLIGHTS_PAGE] : 0,
    [PS.BRB_PAGE] : 0,
    [PS.AIRPORT_HOME_PAGE] : 0,
    [PS.MEET_N_GREET_PAGE] : 0,
    [PS.LOUNGE_LISTING_PAGE] : 0,
    [PS.LOUNGE_DETAIL_PAGE] : 0,
    [PS.ACTIVITIES_PAGE] : 0,
    [PS.CASHBACK_PAGE] : 0,
    [PS.HISTORY_PAGE] : 0,
    [PS.ORDERS_PAGE] : 0,
  };

  constructor() {
  }

  //? Call this method to check if a page needs reload.
  shouldReload(pageType: string){
    return !!this.pageList[pageType];
  }

  //? Call this method when a activity is performed and all page state needs to be updated.
  setReloadAll(){
    Object.keys(this.pageList).forEach(key => {
      this.pageList[key] = 1;
    });
  }

  //? Call this method when a page reload is performed so that it shouldn't trigger another page reload immediatly
  resetState(pageType: string){
    this.pageList[pageType] = !this.pageList[pageType];
  }
}
